import { HeartHandshake, MessageCircleQuestion } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export function ArguingDialog() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          data-testid="arguing-info-button"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm border border-[#C4A265]/50 text-[#8a6d3a] hover:bg-[#C4A265]/10 transition-all shrink-0"
        >
          <MessageCircleQuestion className="h-4 w-4" strokeWidth={1.75} /> Do you find yourself arguing with me?
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#FDFBF7] border-[#E8E3D9] max-w-lg" data-testid="arguing-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-[#2D2A26] flex items-center gap-2.5">
            <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#F5F2EA]">
              <HeartHandshake className="h-4 w-4 text-[#4A5D4E]" strokeWidth={1.5} />
            </span>
            Do you find yourself arguing with me?
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-[#2D2A26] leading-relaxed text-sm">
          <p>
            Are you upset that I'm not giving you the solutions that you want? Well, if you are hoping
            that I will come up with the particular solutions that you have in mind to solve a problem,
            you are likely going to be disappointed.
          </p>
          <p>
            Why? Because that's not the point of this process. The point is to generate solutions that
            meet both your needs — what you care about deep down — and your “opponent's” needs — what
            they care about deep down.
          </p>
          <div className="rounded-xl bg-[#F5F2EA] border border-[#E8E3D9] p-4">
            <p>
              If you don't like the solutions, that means that some need of yours is not being addressed!
              Try to find that need — enter it, and see if we can come up with better solutions.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
